import React, { useState } from "react";
import { getStudentByMobile } from "../api/studentApi";
import { StudentByMobileResponse } from "../types";
import "../styles/PhoneEntry.css";

interface PhoneEntryProps {
  onStudentFound: (mobileNumber: string, profile: StudentByMobileResponse) => void;
}

const PhoneEntry: React.FC<PhoneEntryProps> = ({ onStudentFound }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const digits = mobileNumber.replace(/\D/g, "");
    if (digits.length !== 10) {
      setError("Please enter a valid 10-digit registered phone number");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const response = await getStudentByMobile(digits);

      if (!response.success || !response.data) {
        setError(response.message || "No student found with this mobile number.");
        return;
      }

      if (!response.data.student.isActive) {
        const name =
          response.data.student.fullName?.trim() ||
          `${response.data.student.firstName} ${response.data.student.lastName}`.trim();
        setError(
          `Sorry ${name}, your account is inactive. To proceed, please contact Parthao Lad on 9405703380.`
        );
        return;
      }

      onStudentFound(digits, response.data);
    } catch {
      setError("Unable to fetch student details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="phone-entry-page">
      <div className="phone-entry-card">
        <div className="phone-entry-header">
          <h1>Student Portal</h1>
          <p>Om Sai Reading Room</p>
        </div>

        <form onSubmit={handleSubmit} className="phone-entry-form">
          <label htmlFor="mobileNumber">Enter registered phone number</label>
          <input
            id="mobileNumber"
            type="tel"
            inputMode="numeric"
            maxLength={10}
            value={mobileNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "").slice(0, 10);
              setMobileNumber(value);
              if (error) setError("");
            }}
            placeholder="Enter 10-digit mobile number"
            className={error ? "error" : ""}
            disabled={loading}
            autoFocus
          />
          {error && <span className="error-message">{error}</span>}

          <button
            type="submit"
            className="continue-btn"
            disabled={!mobileNumber || loading}
          >
            {loading ? "Fetching details..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PhoneEntry;
